import React from "react";

export const WA_LINK = "https://wa.me/552420205797?text=Ol%C3%A1!%20Vim%20pelo%20Google%20";

// Inline WhatsApp icon (uses currentColor)
export const WhatsAppIcon = ({ className = "w-5 h-5" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z" />
  </svg>
);

/**
 * 3D CTA button with multi-layer shadow that simulates depth.
 * On hover, button lifts up and shadow shifts to enhance the press-effect.
 */
export const WhatsAppCTA = ({
  children,
  variant = "primary",
  size = "lg",
  className = "",
  testId,
  ...props
}) => {
  const base =
    "btn-3d inline-flex items-center justify-center gap-2.5 font-extrabold uppercase tracking-tight relative isolate select-none focus:outline-none focus-visible:ring-4 focus-visible:ring-[#FDC614]/40 active:translate-y-[3px]";

  const sizes = {
    md: "px-5 py-3 text-sm",
    lg: "px-7 py-4 text-base",
    xl: "px-9 py-5 text-base sm:text-lg",
  };

  const variants = {
    // Brand yellow on dark — main CTA across the site
    primary: "btn-3d--primary",
    // WhatsApp green
    whatsapp: "btn-3d--whatsapp",
    // Outline yellow on dark
    outline: "btn-3d--outline",
    // Dark button on yellow surface
    dark: "btn-3d--dark",
  };

  return (
    <a
      href={WA_LINK}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}
      {...props}
    >
      <span className="btn-3d__shine" aria-hidden="true" />
      <WhatsAppIcon className="w-5 h-5 relative z-10" />
      <span className="relative z-10">{children}</span>
    </a>
  );
};

export const FloatingWhatsApp = () => (
  <a
    href={WA_LINK}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-button"
    aria-label="Falar no WhatsApp"
    className="wa-pulse fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-50 flex items-center justify-center w-16 h-16 sm:w-[72px] sm:h-[72px] rounded-full bg-[#25D366] text-white shadow-[0_18px_40px_-12px_rgba(37,211,102,0.7),0_8px_16px_-4px_rgba(0,0,0,0.4)] hover:scale-110 hover:-translate-y-1 transition-transform duration-200 border-[3px] border-white/10"
  >
    <WhatsAppIcon className="w-8 h-8 sm:w-9 sm:h-9" />
  </a>
);
